export enum DeliveryMethod {
    homedelivery = 'homeDelivery',
    collectionpoint = 'collectionPoint',
    clickandcollect = 'clickAndCollect',
    shiptostore = 'shipToStore',
}
